// The V2 auth contract (bcc.web.api/_Auth/AuthResult.cs, spec §4): every login call returns an AuthResult; My Profile's calls (ProfileController) return their own plain results
export const AuthSteps = {
    Login: 'LOGIN',
    MfaSetup: 'MFA_SETUP',
    MfaVerify: 'MFA_VERIFY',
    PasswordChange: 'PASSWORD_CHANGE',
    Success: 'SUCCESS',
    Fail: 'FAIL',
};
/** The setups a logged-in user does before the app opens (session.postLoginSteps): not login steps, the router shows them */
export const PostLoginSteps = {
    ProfileUpdate: 'PROFILE_UPDATE',
};
/** The reasons that end the login: the account is locked */
export const LOCK_REASONS = ['LOCKED_TEMPORARY', 'LOCKED_INACTIVITY', 'LOCKED'];
export const emptyFlowData = () => ({
    reason: null,
    message: null,
    retryAfterSeconds: null,
    login: null,
    mfaSetup: null,
    mfaVerify: null,
    passwordChange: null,
});
